import { render, staticRenderFns } from "./poweredge.vue?vue&type=template&id=8dcd5d4e&"
import script from "./poweredge.vue?vue&type=script&lang=js&"
export * from "./poweredge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports